export default __webpack_public_path__ + "static/media/img-graf-01@2x.9fd159b1.jpg";